import type { Navegacion } from '../api/operaciones';

/**
 * ¿Abre la Taquilla esta sesión? (G936, ADR-0238): con el permiso y el bloque de la taquilla, es decir, si le llega la
 * entrada `taquilla` del menú de Eventos contratada (al Propietario sin el bloque le llega con «+», y entonces no).
 */
export function conTaquilla(navegacion: Pick<Navegacion, 'items'> | null): boolean {
    return (navegacion?.items ?? []).some((i) => i.key === 'taquilla' && i.module === 'entradas' && !i.not_contracted);
}
